import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './globals.css';
import App from './App';
import reportWebVitals from './reportWebVitals'
import {BrowserRouter} from "react-router-dom";
import '@fortawesome/react-fontawesome';
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"/>


const app = (
  <BrowserRouter>
    <script src="https://code.iconify.design/1/1.0.7/iconify.min.js"></script>
      <App />
  </BrowserRouter>
);
const container = document.getElementById('root');
const root = createRoot(container); 
//ReactDOM.render(app, document.getElementById('root'));
root.render(app);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
